var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<web-component> <div class=\"web-component-bg\"> <div class=\"ulist-box features\"> <h3 class=\"feature-title\" ng-i18next>reservation_accommodation.features</h3> <ul> <li ng-if=\"feature.Value\" class=\"feature\" ng-class=\"feature.Code\" ng-repeat=\"feature in $ctrl.features\"> {{ feature.Name }} : {{ feature.Value }} </li> </ul> </div> </div> </web-component>";
var id1="winresProductFeatures.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresProductFeatures/winresProductFeatures.html
// module id = 438
// module chunks = 2